import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import '../../App.css';

const labels = {
  price: 'The price was too high',
  technical: 'Payment or website problem',
  delivery: 'Delivery concern',
  later: 'Not ready to order yet',
  other: 'Another reason',
};

function CheckoutFeedback() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const reason = params.get('reason') || '';
  const [detail, setDetail] = useState('');
  const [state, setState] = useState(reason === 'other' ? 'writing' : 'saving');
  const [message, setMessage] = useState('');
  const submitted = useRef(false);

  const submit = async (selectedReason, selectedDetail = '') => {
    setState('saving');
    setMessage('');
    try {
      const response = await fetch('/api/checkout-feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, reason: selectedReason, detail: selectedDetail }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || 'Your response could not be saved.');
      setMessage(result.message);
      setState('saved');
    } catch (error) {
      setMessage(error.message);
      setState('error');
    }
  };

  useEffect(() => {
    if (submitted.current || reason === 'other') return;
    submitted.current = true;
    if (!token || !labels[reason]) {
      setMessage('This feedback link is invalid or has expired.');
      setState('error');
      return;
    }
    submit(reason);
  }, [reason, token]);

  return (
    <main className='feedback-page'>
      <img src='/images/mukwei-cinematic-hero-1600.webp' alt='' className='feedback-backdrop' />
      <div className='feedback-shade' />
      <section className='feedback-card'>
        <span className='brand-mark' aria-hidden='true'>M</span>
        <p className='section-kicker'>A private note to Mukwei</p>
        {state === 'writing' ? (
          <>
            <h1>What held you back?</h1>
            <p>Your honest answer goes privately to our team and helps us improve the ordering experience.</p>
            <form onSubmit={(event) => { event.preventDefault(); submit('other', detail); }}>
              <label htmlFor='feedbackDetail'>Tell us what happened</label>
              <textarea
                id='feedbackDetail'
                value={detail}
                onChange={(event) => setDetail(event.target.value)}
                maxLength='500'
                rows='5'
                placeholder='A short explanation is enough…'
                required
              />
              <button type='submit' className='cta-button primary'>Send response</button>
            </form>
          </>
        ) : state === 'saving' ? (
          <div className='feedback-status'><span className='payment-spinner' /><h1>Saving your response…</h1></div>
        ) : (
          <div className={`feedback-status ${state}`}>
            <span className='feedback-symbol'>{state === 'saved' ? '✓' : '!'}</span>
            <h1>{state === 'saved' ? 'Thank you.' : 'We could not save that.'}</h1>
            <p>{message}</p>
            {state === 'saved' && <small>Your response: {labels[reason]}</small>}
          </div>
        )}
        <Link to='/checkout' className='text-link gold'>Return to your reservation <span>→</span></Link>
      </section>
    </main>
  );
}

export default CheckoutFeedback;
